import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import {
  ContainerTypeLegacy,
  ManageStoragePeriods,
  navigateTo,
  useGetViewer,
} from '@amber-ui/core';

function StoragePeriodsRoute() {
  const { bin } = Route.useSearch();
  const { viewer } = useGetViewer();

  const onSubmitSuccess = useCallback(
    ({ grain_bin_id, bin_name }: { grain_bin_id: string; bin_name: string }) => {
      navigateTo('/grain_bin/dashboard', {
        container_name: bin_name,
        container_id: grain_bin_id,
        container_type: ContainerTypeLegacy.bin,
      });
    },
    []
  );

  if (!bin || !viewer) return null;

  return (
    <ManageStoragePeriods
      grain_bin_id={bin}
      onSubmitSuccess={onSubmitSuccess}
      viewer_role={viewer.user.role}
    />
  );
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/storage_periods')({
  component: StoragePeriodsRoute,
});
